const readMore = () => {
  const readMoreButtons = document.querySelectorAll(".readmore-button");
  if (readMoreButtons.length) {
    readMoreButtons.forEach((button) => {
      button.addEventListener("click", function () {
        const readMoreText = this.nextElementSibling;
        const readMoreLabel = this.querySelector(".readmore-label");
        const svgIcon = this.querySelector("svg");

        if (!readMoreText.classList.contains("open")) {
          readMoreText.classList.add("open");
          readMoreLabel.textContent = "Read Less";
          svgIcon.style.transform = "rotate(180deg)";
        } else {
          readMoreText.classList.remove("open");
          readMoreLabel.textContent = "Read More";
          svgIcon.style.transform = "rotate(0deg)";
        }
      });
    });
  }
};

setTimeout(() => {
  readMore();
}, 100);
